import React, { useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import Chart from 'react-apexcharts';

const AlertDistribution = ({ alertDistributions }) => {
  const chartOptions = {
    chart: {
      type: 'donut',
      background: 'transparent',
      toolbar: { show: false }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '50%'
        }
      }
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    colors: ['#0A1551', '#E5E7EB', '#E5E7EB', '#E5E7EB'], // dark blue + light gray segments
    stroke: { show: false },
    tooltip: { enabled: false }
  };

  // const chartSeries = [977, 230, 190, 180]; // For 4 even segments

  // const alertData = [
  //   {
  //     title: "No-go Violations",
  //     count: "3",
  //     status: "Last 24 hours",
  //     statusColor: "#6B7280"
  //   },
  //   {
  //     title: "Gates Open",
  //     count: "2",
  //     status: "Currently open",
  //     statusColor: "#6B7280"
  //   },
  //   {
  //     title: "Fire Alerts",
  //     count: "0",
  //     status: "All clear",
  //     statusColor: "#6B7280"
  //   },
  //   {
  //     title: "Intruders",
  //     count: "1",
  //     status: "Active alert",
  //     statusColor: "#EF4444"
  //   }
  // ];


  // Extract the result array from the object or use empty array
  const validAlertDistributions = Array.isArray(alertDistributions?.result) ? alertDistributions.result : [];

  const chartSeries = validAlertDistributions.map(item => item.alert_count) || [];

  const alertData = validAlertDistributions.map(item => ({
    title: item.module_name.replace(/_/g, ' '),
    count: item.alert_count.toString(),
    status: "Live", // You can customize this if needed
    statusColor: item.alert_count > 0 ? "#EF4444" : "#6B7280"
  })) || [];

  const totalAlerts = chartSeries.reduce((acc, curr) => acc + curr, 0);


  // useEffect(() => {
  //   console.log("----------------")
  //    console.log(alertDistributions)
  // }, [alertDistributions])
  console.log("alertDistributions", alertData);

  return (
    <div style={{
      overflowX: 'auto',
      width: '100%'
    }}>
      <Card style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        padding: '24px',
        border: 'none',
        minWidth: '600px' // Fixed minimum width to ensure content doesn't get crushed
      }}>
        <CardBody className="p-0">
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#091954',
            marginBottom: '24px'
          }}>
            Alert Distribution by Type
          </h2>

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            {/* Donut Chart */}
            <div style={{
              position: 'relative',
              width: '200px',
              height: '200px',
              flexShrink: 0 // Prevents chart from shrinking
            }}>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="donut"
                height={200}
                width={200}
              />
              {/* Center Value */}
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '14px',
                fontWeight: '500',
                color: '#1E40AF'
              }}>
                Total Alerts
                <p style={{ textAlign: "center", fontWeight: "500" }}>
                  {totalAlerts || 0}
                </p>
              </div>
            </div>

            {/* Alert Info Panel */}
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              marginLeft: '32px',
              minWidth: '300px' // Ensures alert panel has minimum width
            }}>
              {alertData.map((alert, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px'
                }}>
                  <div>
                    <div style={{
                      fontSize: '14px',
                      fontWeight: '500',
                      color: '#111827'
                    }}>
                      {alert.title}
                    </div>
                    <div style={{
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#111827',
                      marginTop: '2px'
                    }}>
                      {alert.count}
                    </div>
                  </div>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    color: alert.statusColor,
                    textAlign: 'right'
                  }}>
                    {alert.status}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default AlertDistribution;